module.exports = __webpack_public_path__ + "img/9-min.ca45cead.jpg";